<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{title}} Table</h3>
            <!-- <button class="btn btn-success" (click)="initModal('create')">Create</button> -->
          </div>
          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>DEVICE ID</th>
                  <th>DEVICE TYPE</th>
                  <th>DEVICE LANGUAGE</th>
                  <th>BOARD MANAGE</th>
                  <th>LAST LOGIN</th>
                  <th class="w-1">UPDATE AT</th>
                  <!-- <th class="w-1">ACT.</th> -->
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let device of deviceList">
                  <td>
                    <code>{{ device.deviceId }}</code>
                  </td>
                  <td>
                    <span>{{ device.deviceType }}</span>
                  </td>
                  <td>
                    <span>{{ device.deviceLanguage }}</span>
                  </td>
                  <td>
                    <button (click)="showBoard(device)" class="btn btn-success">{{device.listBoard.length}} board(s)</button>
                  </td>
                  <td>
                    <span>{{ device.lastLoginAt | date:'hh:mm dd-MM-yyyy' }}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ device.updatedAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="deviceList?.length === 0">
                  <td class="text-center" colspan="8">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="deviceList?.length !== 0">
                  <td colspan="8">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + deviceList?.length
                    }} of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>


            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>

  </section>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content" *ngIf="deviceInfo">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title"> List Board manage by <code>{{deviceInfo.deviceId}}</code> </h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <tr>
                <td>BOARD ID</td>
                <td>BOARD CODE</td>
                <td>BATTERY STATUS</td>
                <td>LAST ONLINE</td>
              </tr>
              <tr *ngFor="let board of deviceInfo.listBoard">
                <td>{{ board.boardId }}</td>
                <td><code>{{ board.boardCode }}</code></td>
                <td class="text-center">{{ board.batteryStatus }}%</td>
                <td>{{ board.lastOnlineAt | date:'hh:mm dd-MM-yyyy'  }}</td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/device/device.component.html